import type { PostTeaserFragment, SubmissionTeaserFragment } from '$gen/graphql';

export const isPostTeaserFragment = (item): item is PostTeaserFragment => {
    return (item as PostTeaserFragment).__typename === 'posts_default_Entry';
};

export const isSubmissionTeaserFragment = (item): item is SubmissionTeaserFragment => {
    return (item as SubmissionTeaserFragment).__typename === 'exhibition_Submission';
};
